import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Layout from '../components/Layout';
import VideosMenu from '../components/VideosMenu';
import '../assets/styles/components/Videos.sass';

class VideosStageFive extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            data: [],
        }
    }
    
    componentDidMount() {
        
        fetch('https://la-leyenda.com/2018/api/videos/etapa5')
        .then(res => res.json())
        .then(
        (res) => {
            this.setState({
                isLoaded: true,
                data: res
            });
        },
        
        (error) => {
            this.setState({
                isLoaded: true,
                error
            });
        }
        )
    
        document.getElementById('videos').classList.add('active')
        document.getElementById('videosEtapa5').classList.add('active')
    }
  
    componentWillUnmount() {
        document.getElementById('videos').classList.remove('active')
        document.getElementById('videosEtapa5').classList.remove('active')
    }
    
    render() {
        return(
            <Layout>
                <VideosMenu/>
                <div className="row videos-main">
                    <div className="container">
                        <div className="row no-gutters">
                            <div className="col-xs-12">
                                <div className="custom">
                                    {this.state.data.map((item) => (
                                        <div>
                                            <strong>
                                                <span className="videos-main-title">
                                                {item.title}
                                                </span>
                                            </strong>
                                            <div className="embed-responsive embed-responsive-16by9">
                                                { ReactHtmlParser(item.video) }
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }
}

export default VideosStageFive;